<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2.15039C12.4694 2.15039 12.8496 2.53056 12.8496 3V21L12.8457 21.0869C12.8022 21.5155 12.4401 21.8496 12 21.8496C6.56 21.8496 2.15039 17.44 2.15039 12C2.15039 6.56 6.56 2.15039 12 2.15039ZM11.1504 3.89355C7.04853 4.31843 3.84961 7.78578 3.84961 12C3.84961 16.2142 7.04857 19.6806 11.1504 20.1055V3.89355Z"
      fill="white" />
    <path
      d="M18.248 17.1855C18.5352 16.8144 19.0691 16.7454 19.4404 17.0322C19.8117 17.3194 19.8798 17.8533 19.5928 18.2246C18.7952 19.2557 17.3608 20.4221 16.0127 21C15.5813 21.1849 15.0815 20.985 14.8965 20.5537C14.7116 20.1223 14.9114 19.6225 15.3428 19.4375C16.4095 18.9802 17.6167 18.0015 18.248 17.1855Z"
      fill="white" />
    <path
      d="M20.5684 9.14551C21.0248 9.0361 21.4843 9.31697 21.5938 9.77344C21.892 11.0177 21.9682 12.8494 21.5684 14.2822C21.4422 14.7343 20.9726 14.9991 20.5205 14.873C20.0686 14.7467 19.8045 14.2772 19.9307 13.8252C20.237 12.7274 20.1864 11.1964 19.9404 10.1699C19.831 9.71352 20.112 9.25506 20.5684 9.14551Z"
      fill="white" />
    <path
      d="M14.9824 3.4541C15.1652 3.02176 15.6643 2.8192 16.0967 3.00195C17.4393 3.56971 18.695 4.62797 19.6357 5.80078C19.9292 6.16697 19.87 6.70148 19.5039 6.99512C19.1378 7.28862 18.6033 7.23022 18.3096 6.86426C17.499 5.8537 16.4572 5.00084 15.4346 4.56836C15.0022 4.38554 14.7997 3.88645 14.9824 3.4541Z"
      fill="white" />
  </svg>
</template>
